module.exports = __webpack_public_path__ + "static/media/29EUNOG2.1ed9dc89.jpg";